import workspaceQuery from 'graphql/queries/supplier/PurchaseAllocationWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/PurchaseAllocationListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchaseAllocationQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchaseAllocationDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchaseAllocationMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/supplier/SavePurchaseAllocationTempMutation.graphql';
import fragment from 'graphql/fragments/supplier/PurchaseAllocationFragment.graphql';

import { formActionsForPermissions } from '../../../actions/supplier/PurchaseAllocationAction';

const PurchaseAllocation = {
  type: 'PurchaseAllocation',
  title: 'Supplier Allocations',
  formUrl: '/Suppliers/Allocation/Details/',
  formTitle: 'Supplier Allocations',
  workspaceUrl: '/Suppliers/Allocation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  fragment,
  screenReference: 'SUPPLIER_ALLOCATIONS',
  actions: formActionsForPermissions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'REVERSED'],
    },
  ],
};

export default PurchaseAllocation;
